export const WANT_TO_ACHIVE = "WANT_TO_ACHIVE";
export const CREATE_USER = "CREATE_USER";

export const steps = [
  {
    id: WANT_TO_ACHIVE,
    title: "Which option best describes your relationship with money?",
  },
  {
    id: CREATE_USER,
    title:
      "Now that you've taken the first step towards financial wellness, let's create your free profile.",
  },
];
